// Image formats accepted by every marketing upload (backend: functions_helper/uploadGuard.js).
export const IMAGE_ACCEPT = '.jpg,.jpeg,.webp';
export const IMAGE_FORMATS_LABEL = 'JPG, WEBP';
export const IMAGE_FORMAT_ERROR = 'Format invalide. Formats acceptés : JPG, JPEG, WEBP.';

export const isAllowedImage = (file: File): boolean => /\.(jpe?g|webp)$/i.test(file.name);

export const readImagePreview = (file: File, done: (url: string) => void): void => {
  const reader = new FileReader();
  reader.onload = (e) => done(e.target?.result as string);
  reader.readAsDataURL(file);
};
